/* Collection Circles HH — Arrow scroll + RTL aware + disabled-state */
(function () {
  'use strict';
  const SEL = '.hh-circles';

  class HHCircles {
    constructor(root) {
      this.root = root;
      this.scroller = root.querySelector('[data-scroller]');
      this.prev = root.querySelector('[data-prev]');
      this.next = root.querySelector('[data-next]');
      this.isRTL = getComputedStyle(root).direction === 'rtl';
      if (!this.scroller) return;
      this.bind();
      this.updateButtons();
    }

    bind() {
      this.prev?.addEventListener('click', () => this.scrollBy(-1));
      this.next?.addEventListener('click', () => this.scrollBy(1));
      this.scroller.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons());
    }

    scrollBy(direction) {
      const amount = this.scroller.clientWidth * 0.6;
      // In RTL, scrollLeft is negative when scrolled toward the start; modern browsers normalize this
      const delta = (this.isRTL ? -direction : direction) * amount;
      this.scroller.scrollBy({ left: delta, behavior: 'smooth' });
    }

    updateButtons() {
      const s = this.scroller;
      const max = s.scrollWidth - s.clientWidth;
      // Normalize for RTL: scrollLeft may be negative
      let progress = s.scrollLeft;
      if (this.isRTL) progress = Math.abs(progress);
      const atStart = progress <= 2;
      const atEnd = progress >= max - 2;
      if (this.prev) this.prev.disabled = this.isRTL ? atEnd : atStart;
      if (this.next) this.next.disabled = this.isRTL ? atStart : atEnd;
    }
  }

  function init() {
    document.querySelectorAll(SEL).forEach((el) => {
      if (el.__hhCircles) return;
      el.__hhCircles = new HHCircles(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
